import React from "react";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";

const SalaryMappingPopup = ({ data, data1 }) => {
  
  return (
    <div className="mx-auto mt-2 md:w-2/5 w-full flex items-center justify-center">
      <div className="relative w-full h-full max-w-xl md:h-auto">
        <div className="relative bg-white rounded-lg shadow">
          <div className="px-6 py-6 lg:px-8">
            <div className="flex gap-2 flex-col">
            <InputText
              inputType="date"
              title="Date"
              classStar="text-red-500"
              name="date"
              disabled={true}
              content={(data?.Date ?? "").split("T")[0]}
            />

            <AutoDropDown
              selectedOption={{value : data.StaffName, label : data.StaffName1}}
              title="Staff Name"
              classStar={"text-red-500"}
              inputType="dropdown"
              options={[data1[0]]}
              name="mstStaffNameId"
              disabled={true}
              placeholder="Staff Name"
              Class="custom-class"
              // tabIndex="1"
              maxLength={50}
            />


            <AutoDropDown
              selectedOption={{value : data.SalaryGrade, label : data.Grade}}
              title="Salary Grade"
              classStar={"text-red-500"}
              inputType="dropdown"
              options={[data1[1]]}
              name="salaryGrade"
              disabled={true}
              placeholder="Grade"
              Class="custom-class"
              // tabIndex="1"
              maxLength={50}
            />

          </div>

        </div>
      </div>
    </div>
    </div>
    
  );
};
export default SalaryMappingPopup;

